import { render, staticRenderFns } from "./IconScreenTime.vue?vue&type=template&id=61148490&"
import script from "./IconScreenTime.vue?vue&type=script&lang=js&"
export * from "./IconScreenTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports